// @ts-nocheck
import {
  SAVE_DASHBOARD_FILTERS_REQUEST,
  SAVE_DASHBOARD_FILTERS_SUCCESS,
  SAVE_DASHBOARD_FILTERS_FAILURE,
  GET_DASHBOARD_FILTERS_REQUEST,
  GET_DASHBOARD_FILTERS_SUCCESS,
  GET_DASHBOARD_FILTERS_FAILURE,
  DELETE_DASHBOARD_FILTERS_REQUEST,
  DELETE_DASHBOARD_FILTERS_SUCCESS,
  DELETE_DASHBOARD_FILTERS_FAILURE,
  UPDATE_DASHBOARD_FILTERS,
} from "../constants/dashboardFilters";

export const initialState = {
  originalFilters: {}, // To keep track of original filters for comparison
  savedFilters: {}, // Object to store filters per dashboard: { "dashboard-id": { filters }, ... }
  isSaving: false,
  isLoading: true,
  isDeleting: false,
  saveError: null,
  loadError: null,
  deleteError: null,
  lastSavedAt: null,
};

const dashboardFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    // Save Filters
    case SAVE_DASHBOARD_FILTERS_REQUEST:
      return {
        ...state,
        isSaving: true,
        saveError: null,
      };
    case SAVE_DASHBOARD_FILTERS_SUCCESS:
      return {
        ...state,
        isSaving: false,
        savedFilters: {
          ...state.savedFilters,
          [action.payload.dashboardId]: action.payload.data,
        },
        originalFilters: {
          ...state.originalFilters,
          [action.payload.dashboardId]: action.payload.data,
        },
        saveError: null,
        lastSavedAt: new Date().toISOString(),
      };
    case SAVE_DASHBOARD_FILTERS_FAILURE:
      return {
        ...state,
        isSaving: false,
        saveError: action.payload,
      };

    // Get Filters
    case GET_DASHBOARD_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        loadError: null,
      };
    case GET_DASHBOARD_FILTERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        savedFilters: {
          ...state.savedFilters,
          [action.payload.dashboardId]: action.payload.data,
        },
        originalFilters: {
          ...state.originalFilters,
          [action.payload.dashboardId]: action.payload.data,
        },
        loadError: null,
      };
    case GET_DASHBOARD_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        loadError: action.payload,
        // Don't clear other dashboards' filters
      };

    // Delete Filters
    case DELETE_DASHBOARD_FILTERS_REQUEST:
      return {
        ...state,
        isDeleting: true,
        deleteError: null,
      };
    case DELETE_DASHBOARD_FILTERS_SUCCESS:
      const { [action.payload.dashboardId]: deletedDashboard, ...remainingFilters } = state.savedFilters;
      const { [action.payload.dashboardId]: deletedOriginal, ...remainingOriginals } = state.originalFilters;
      return {
        ...state,
        isDeleting: false,
        savedFilters: remainingFilters,
        originalFilters: remainingOriginals,
        deleteError: null,
        lastSavedAt: null,
      };
    case DELETE_DASHBOARD_FILTERS_FAILURE:
      return {
        ...state,
        isDeleting: false,
        deleteError: action.payload,
      };

    // Update Filters (Local)
    case UPDATE_DASHBOARD_FILTERS:
      return {
        ...state,
        savedFilters: {
          ...state.savedFilters,
          [action.payload.dashboardId]: action.payload.data,
        },
      };

    default:
      return state;
  }
};

export default dashboardFiltersReducer;